import { FirebaseOptions } from '@firebase/app';
import { PropsWithChildren, useEffect } from 'react';
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

const FirebaseProvider = ({
  children,
  firebaseConfig,
}: PropsWithChildren<{
  firebaseConfig: FirebaseOptions;
}>) => {
  useEffect(() => {
    const app = initializeApp(firebaseConfig);
    getAnalytics(app);
  }, [firebaseConfig]);
  return children;
};

export default FirebaseProvider;
